import React, { ReactNode, FC } from 'react';
import { QualityCheckContext } from './context';
import { useFormData } from './hooks/useFormData';
import { useQuestionnaire } from './hooks/useQuestionnaire';

// --- Interfaces ---

interface QualityCheckOptions {
    clientId: number;
    productId: number;
}

interface GetValueParams {
    clientId: number;
    questionnaire: any;
    formData: any;
}

export interface QualityCheckContextValue {
    clientId: number;
    questionnaire: any;
    formData: any;
    getValue: (callback: (params: GetValueParams) => any) => any;
}

interface Props {
    options: QualityCheckOptions;
    children: ReactNode;
}

// --- Component ---

export const QualityCheckProvider: FC<Props> = ({ options, children }) => {
    const { clientId, productId } = options;

    // It is recommended to type these hooks in their respective files,
    // so 'questionnaire' and 'formData' inherit those types here.
    const questionnaire = useQuestionnaire({ productId, clientId });
    const formData = useFormData({ serverData: questionnaire?.data });

    const getValue = (callback: (params: GetValueParams) => any) => callback({
        clientId,
        questionnaire,
        formData,
    });

    return (
        <QualityCheckContext.Provider
            value={{
                clientId,
                questionnaire,
                formData,
                getValue,
            }}
        >
            {children}
        </QualityCheckContext.Provider>
    );
};
